<template>
	<div class="smsAssets">
		<div class="label">可用短信条数：</div>
		<template v-if="smsAssets">
			<template v-if="smsAssets.isFree">
				<template v-if="smsAssets.remainSmsNum">
					<div class="number">
						<span>{{ smsAssets.remainSmsNum }}</span
						>条
					</div>
					<div class="validity">
						（{{ smsAssets.smsFreeDueDate | timeFilterGlobal('YYYY-MM-DD') }}前不扣除短信条数）
						<el-tooltip
							class="item"
							offset="10"
							effect="dark"
							content="老用户会员期内限时免费，会员到期后按需购买"
							placement="top-start"
						>
							<i class="iconfont icon-bangzhushuoming"></i>
						</el-tooltip>
					</div>
				</template>
				<template v-else>
					<div class="validity">
						不限（{{ smsAssets.smsFreeDueDate | timeFilterGlobal('YYYY-MM-DD') }}到期)
						<el-tooltip
							class="item"
							offset="10"
							effect="dark"
							content="老用户会员期内限时免费，会员到期后按需购买"
							placement="top-start"
						>
							<i class="iconfont icon-bangzhushuoming"></i>
						</el-tooltip>
					</div>
				</template>
			</template>
			<div v-else class="number">
				<span>{{ smsAssets.remainSmsNum }}</span
				>条
			</div>
			<div v-if="showBuyBtn" class="handleBtn" @click="toBuy">
				去购买<i class="iconfont icon-youdanjiantou"></i>
			</div>
		</template>
	</div>
</template>

<script>
// const defaultInfo = {
// 	remainSmsNum: 0, //剩余短信包数量
// 	totalConsumeSmsNum: 0, //总消耗数量
// 	liveConsumeSmsNum: 0, //映目直播消耗数量
// 	photoLiveConsumeSmsNum: 0, //云摄影消耗数量
// 	smsFreeDueDate: 0, //短信免费使用到期时间
// }

import { mapState, mapActions } from 'vuex';
import config from '@/services/config';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {};
	},
	computed: {
		...mapState({
			smsAssets: (state) => state.state.smsAssets,
		}),
		...mapGetters({
			isCompany: 'isCompany',
			isManager: 'company/isManager',
		}),
		showBuyBtn() {
			if (this.isCompany) {
				return this.isManager;
			} else {
				return true;
			}
		},
	},
	mounted() {
		if (!this.smsAssets) {
			if (this.$route.name === 'album.watch') {
				this.getAlbumsSmsAssets(this.$route.params.albumId);
			} else {
				this.getCurrentSmsAssets(this.$route.params.id);
			}
		}
	},
	methods: {
		...mapActions({
			getCurrentSmsAssets: 'getCurrentSmsAssets',
			getAlbumsSmsAssets: 'getAlbumsSmsAssets',
		}),
		toBuy() {
			let url = `${config.host}/purchase/service?servicetab=smsPlan`;
			window.open(url, '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
.smsAssets {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #1d2129;
	line-height: 20px;
	.number {
		color: #ff880f;
	}
	.handleBtn {
		cursor: pointer;
		color: #165dff;
		display: inline-flex;
		align-items: center;
		margin-left: 16px;
		.iconfont {
			margin-left: 2px;
		}
	}
	.validity {
		.iconfont {
			font-size: 14px;
			color: #4e5969;
			cursor: pointer;
		}
	}
}
</style>
